import swal from 'sweetalert'
import { getHostAdapter } from './hostAdapter'
const uuidv4 = require('uuid/v4')

const hostAdapter = getHostAdapter()

/*
 * Action types
 */
export const actionTypes = {
  SET_HOST: 'SET_HOST',
  ADD_RULE: 'ADD_RULE',
  REORDER_RULE: 'REORDER_RULE',
  CHANGE_RULE: 'CHANGE_RULE',
  DELETE_RULE: 'DELETE_RULE',
  SELECT_RULE: 'SELECT_RULE',
  DESELECT_RULE: 'DESELECT_RULE',
  ADD_EXAMPLE: 'ADD_EXAMPLE',
  CHANGE_EXAMPLE: 'CHANGE_EXAMPLE',
  DELETE_EXAMPLE: 'DELETE_EXAMPLE',
  ADD_QUESTION: 'ADD_QUESTION',
  CHANGE_QUESTION: 'CHANGE_QUESTION',
  DELETE_QUESTION: 'DELETE_QUESTION',

  INCREMENT_SAVE_COUNTER: 'INCREMENT_SAVE_COUNTER',
  DECREMENT_SAVE_COUNTER: 'DECREMENT_SAVE_COUNTER',

  LOAD_EXAMPLE_MAP: 'LOAD_EXAMPLE_MAP',

  ALLOW_AUTOFOCUS: 'ALLOW_AUTOFOCUS',
  CLOSE_EXPORT_DIALOGUE: 'CLOSE_EXPORT_DIALOGUE',
  OPEN_EXPORT_DIALOGUE: 'OPEN_EXPORT_DIALOGUE'
}

/*
 * action creators
 */
export const setHost = (mode) => {
  return {
    type: actionTypes.SET_HOST,
    value: mode
  }
}

export const incrementSaveCounter = () => {
  return {
    type: actionTypes.INCREMENT_SAVE_COUNTER
  }
}

export const decrementSaveCounter = () => {
  return dispatch => {
    setTimeout(() => dispatch({ type: actionTypes.DECREMENT_SAVE_COUNTER }), 500)
  }
}

export const addRule = (rowIndex) => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.ADD_RULE,
      id: uuidv4(),
      rowIndex: rowIndex
    })
    dispatch(saveExampleMap())
  }
}

export const changeRule = (id, value) => {
  return {
    type: actionTypes.CHANGE_RULE,
    id: id,
    value: value
  }
}

export const reorderRule = (
  sourceRuleRowIndex,
  sourceRuleIndex,
  destinationRuleRowIndex,
  destinationRuleIndex) => {
  window.amplitude.getInstance().logEvent('em_reorder_rules')
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.REORDER_RULE,
      sourceRuleRowIndex: sourceRuleRowIndex,
      sourceRuleIndex: sourceRuleIndex,
      destinationRuleRowIndex: destinationRuleRowIndex,
      destinationRuleIndex: destinationRuleIndex
    })
    dispatch(saveExampleMap())
  }
}

export const saveExampleMap = () => {
  // consider moving save check before save.

  return async (dispatch, getState) => {
    dispatch(incrementSaveCounter())
    const currentState = getState()

    window.amplitude.getInstance().logEvent('em_save_examplemap')

    const stateToSave = {
      name: currentState.exampleMap.name,
      definitionOfDone: currentState.exampleMap.definitionOfDone,
      rules: currentState.rules,
      examples: currentState.examples,
      questions: currentState.questions
    }

    try {
      const fetchRequired = await hostAdapter.save(stateToSave)
      if (fetchRequired) {
        dispatch(fetchExampleMapAsync())
      }
    } catch (error) {
      swal('Oops', 'Unable to save Example Map', 'error')
    }
    dispatch(decrementSaveCounter())
  }
}

export const saveRule = () => {
  return dispatch => {
    dispatch(saveExampleMap())
  }
}

export const deleteRule = (id) => {
  return dispatch => {
    dispatch({ type: actionTypes.DELETE_RULE, id: id })
    dispatch(saveExampleMap())
  }
}

export const addExample = (ruleId) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.ADD_EXAMPLE, id: uuidv4(), ruleId: ruleId })
    dispatch(saveExampleMap())
  }
}

export const changeExample = (id, value) => {
  return {
    type: actionTypes.CHANGE_EXAMPLE,
    id: id,
    value: value
  }
}

export const saveExample = () => {
  return dispatch => {
    dispatch(saveExampleMap())
  }
}

export const deleteExample = (id) => {
  return dispatch => {
    dispatch({ type: actionTypes.DELETE_EXAMPLE, id: id })
    dispatch(saveExampleMap())
  }
}

export const addQuestion = (exampleMapId) => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.ADD_QUESTION,
      id: uuidv4()
    })
    dispatch(saveExampleMap())
  }
}

export const changeQuestion = (id, value) => {
  return {
    type: actionTypes.CHANGE_QUESTION,
    id: id,
    value: value
  }
}

export const saveQuestion = (id, value) => {
  return dispatch => {
    dispatch(saveExampleMap())
  }
}

export const deleteQuestion = (id) => {
  return dispatch => {
    dispatch({ type: actionTypes.DELETE_QUESTION, id: id })
    dispatch(saveExampleMap())
  }
}

const loadExampleMap = (data) => {
  return {
    type: actionTypes.LOAD_EXAMPLE_MAP,
    data: data
  }
}

export const fetchExampleMapAsync = () => {
  return async dispatch => {
    try {
      identifyCustomer()
      let state = await hostAdapter.load()
      dispatch(loadExampleMap(state))
      setTimeout(() => dispatch({ type: actionTypes.ALLOW_AUTOFOCUS }), 500)
    } catch (error) {
      console.log(error)
      window.amplitude.getInstance().logEvent('em_cannot_load')
      swal('Unable to load Example Map', 'Please contact support@teamuplabs.com', 'error')
    }
  }
}

export const selectRule = (ruleId) => {
  return {
    type: actionTypes.SELECT_RULE,
    id: ruleId
  }
}

export const deselectRule = (ruleId) => {
  return {
    type: actionTypes.DESELECT_RULE,
    id: ruleId
  }
}

const identifyCustomer = async () => {
  const customer = await hostAdapter.getCustomerIdentifier()
  let identify = new window.amplitude.Identify().set('customer', customer)
  window.amplitude.getInstance().identify(identify)
}

export const clearExampleMap = () => {
  return async dispatch => {
    let state = await hostAdapter.loadInitialExampleMap()
    dispatch(loadExampleMap(state))
    dispatch(saveExampleMap())
  }
}

export const closeExportDialogue = (mode) => {
  return {
    type: actionTypes.CLOSE_EXPORT_DIALOGUE
  }
}

export const openExportDialogue = (mode) => {
  return {
    type: actionTypes.OPEN_EXPORT_DIALOGUE
  }
}
